import React, { useState } from "react";
import {
  createInitialForm,
  validateRequiredField,
} from "../../../common/common";
import { adminLoginData } from "../../../assets/lib/login";
import { COLLECTION, SESSION } from "../../../data/constant";
import {
  Timestamp,
  addDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import Layout from "./Layout";

const CampusLogin = () => {
  const [loginState, setLoginState] = useState(
    createInitialForm(adminLoginData)
  );
  const [loginFailedText, setLoginFailedText] = useState("");
  const [errorFields, setErrorFields] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const navigate = useNavigate();

  const getLoginInput = (event) => {
    const { name, value } = event.target;

    if (errorFields.includes(name) && value) {
      setErrorFields((prev) => prev.filter((k) => k !== name));
    }

    setLoginState((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
    const errors = validateRequiredField(adminLoginData, loginState);
    setErrorFields(errors);

    if (errors.length !== 0) return;

    try {
      setSubmitLoading(true);
      setLoginFailedText("");

      const campusRef = collection(db, COLLECTION.CAMPUS);
      const campusSnapshot = await getDocs(campusRef);

      let matchedAdmin = null;
      let matchedCampus = null;

      campusSnapshot.forEach((doc) => {
        const campusData = doc.data();

        const admin = campusData?.campusAdmins?.find(
          (admin) =>
            admin.email === loginState.email &&
            admin.password === loginState.password &&
            admin.disabled === false
        );

        if (admin && !matchedAdmin) {
          matchedAdmin = admin;
          matchedCampus = {
            ...campusData,
            id: doc.id,
          };
        }
      });

      if (!matchedAdmin) {
        setLoginFailedText("Invalid email or password");
        setSubmitLoading(false);
        return;
      }

      // Create campus session
      const sessionRef = collection(db, COLLECTION.CAMPUS_SESSION);
      const sessionDoc = await addDoc(sessionRef, {
        email: matchedAdmin.email,
        campusId: matchedCampus.id,
        campusName: matchedCampus.campusName,
        sessionStart: Timestamp.now(),
      });

      localStorage.setItem(
        SESSION.CAMPUS_SESSION_ID,
        sessionDoc.id
      );

      setSubmitLoading(false);
      navigate(routes.CAMPUS_PODS);
    } catch (error) {
      console.error("Login error:", error);
      setSubmitLoading(false);
      setLoginFailedText("Something went wrong. Try again.");
    }
  };

  return (
    <Layout
      loginState={loginState}
      loginFailedText={loginFailedText}
      errorFields={errorFields}
      getLoginInput={getLoginInput}
      handleLogin={handleLogin}
      submitLoading={submitLoading}
    />
  );
};

export default CampusLogin;
